module.exports = __webpack_public_path__ + "static/media/Structure3D.01e70782.svg";